import { Box, Chip, Typography } from '@mui/material'
import { AutoAwesome } from '@mui/icons-material'
import { getCondoType } from '../../services/Main/AuthStorage'

const suggestionsByType = {
  CONDO: [
    { label: 'Resumo das despesas', message: 'Qual o resumo das despesas deste mês?' },
    { label: 'Faturas vencidas', message: 'Quais faturas estão vencidas?' },
    { label: 'Como criar despesa', message: 'Como criar uma nova despesa?' },
    { label: 'Unidades inadimplentes', message: 'Quais unidades estão inadimplentes?' },
  ],
  RENT: [
    { label: 'Resumo financeiro', message: 'Qual o resumo financeiro deste mês?' },
    { label: 'Contratos a vencer', message: 'Quantos contratos vencem nos próximos 30 dias?' },
    { label: 'Faturas vencidas', message: 'Quais faturas estão vencidas?' },
    { label: 'Reajuste de aluguel', message: 'Como funciona o reajuste de aluguel?' },
  ],
  BUSINESS: [
    { label: 'Fluxo de caixa', message: 'Qual o resumo do fluxo de caixa deste mês?' },
    { label: 'Faturas em aberto', message: 'Quais faturas estão em aberto?' },
    { label: 'Cadastrar cliente', message: 'Como cadastrar um novo cliente?' },
    { label: 'Contratos ativos', message: 'Quantos contratos estão ativos?' },
  ],
}

const defaultSuggestions = [
  { label: 'Resumo financeiro', message: 'Qual o resumo financeiro deste mês?' },
  { label: 'Faturas vencidas', message: 'Quais faturas estão vencidas?' },
  { label: 'Como usar o sistema', message: 'Quais são as principais funcionalidades do sistema?' },
  { label: 'Ajuda', message: 'O que você pode fazer por mim?' },
]

const SuggestedQuestions = ({ onSelect }) => {
  const condoType = getCondoType()
  const suggestions = suggestionsByType[condoType] || defaultSuggestions

  return (
    <Box sx={{ p: 3, textAlign: 'center', flex: 1, display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
      <AutoAwesome sx={{ fontSize: 48, color: 'primary.main', mb: 1, mx: 'auto' }} />
      <Typography variant="subtitle1" fontWeight="bold" gutterBottom>
        Olá! Como posso ajudar?
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
        Pergunte sobre finanças, contratos ou como usar o sistema.
      </Typography>
      <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1, justifyContent: 'center' }}>
        {suggestions.map((s, i) => (
          <Chip
            key={i}
            label={s.label}
            variant="outlined"
            onClick={() => onSelect(s.message)}
            sx={{ cursor: 'pointer' }}
          />
        ))}
      </Box>
    </Box>
  )
}

export default SuggestedQuestions
